var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { fromSize } from '../../../../utilities/media';
export var LegendCompactContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n  padding: 0 ", ";\n  display: flex;\n  flex-direction: row;\n"], ["\n  margin-top: ", ";\n  padding: 0 ", ";\n  display: flex;\n  flex-direction: row;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xl;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
});
export var LegendExtendedContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n  gap: ", ";\n  width: 100%;\n  overflow: hidden;\n  margin-top: ", ";\n\n  ", " {\n    flex-flow: row nowrap;\n    margin-top: ", ";\n  }\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n  gap: ", ";\n  width: 100%;\n  overflow: hidden;\n  margin-top: ", ";\n\n  ", " {\n    flex-flow: row nowrap;\n    margin-top: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.sm;
}, fromSize('md'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xl;
});
export var LegendItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n  margin-right: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: baseline;\n  margin-right: ", ";\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
});
var LegendIcon = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: ", ";\n  width: 16px;\n  height: 16px;\n"], ["\n  display: inline-block;\n  margin-right: ", ";\n  width: 16px;\n  height: 16px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
});
export var LegendIconLow = styled(LegendIcon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.chart.primary.child2;
});
export var LegendIconHigh = styled(LegendIcon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.chart.primary.child1;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;